module.exports = __webpack_public_path__ + "img/nicetohave-product-design-05.5e201bd2.jpg";